import type { A11yIgnoredViolation } from '@overlayqa/shared';
import { fetchApi } from './client';
import { log } from '@/lib/logger';
import { MUTATION_TIMEOUT_MS, SCREEN_READ_TIMEOUT_MS } from './requestTimeout';

log.info('[api/a11yIgnored] Module loaded');

export const a11yIgnoredDashboardApi = {
  list(token: string, projectId: string): Promise<A11yIgnoredViolation[]> {
    log.info('[api/a11yIgnored] list', { projectId });
    return fetchApi<A11yIgnoredViolation[]>(`/projects/${projectId}/a11y-ignored`, {
      token,
      method: 'GET',
      timeoutMs: SCREEN_READ_TIMEOUT_MS,
    });
  },

  unignoreBulk(token: string, projectId: string, ids: string[]): Promise<{ deletedCount: number }> {
    log.info('[api/a11yIgnored] unignoreBulk', { projectId, ids });
    return fetchApi<{ deletedCount: number }>(`/projects/${projectId}/a11y-ignored`, {
      token,
      method: 'DELETE',
      timeoutMs: MUTATION_TIMEOUT_MS,
      body: JSON.stringify({ ids }),
    });
  },
};
